export default __webpack_public_path__ + "static/media/cover_color_1.d6b6689d.png";